import React, { useCallback, useState } from "react";
import { ListHeader } from "../..";
import { tableHasAction } from "./utilsV2Table";
import { createUseStyles } from "react-jss";
import { classNames } from "../../utils/classNames";
import { TableHeaderCell } from "./TableHeaderCell";
import { rowValue } from "./sharedJSS";
import { useTableContext } from "../../hooks/useTableContext";
import { THEME } from "../../theming/theming";
import { SelectAllTableCheckbox } from "../SelectAllTableCheckbox";
import { SkeletonCheckbox } from "../SkeletonCheckbox";
export function V2TableHeader(props) {
    const { gridClassName, isBulk, onSelectAll, tableTheme } = useTableContext();
    const { sortColumn, sortDirection, onSort, headings, id, styling, dataId, dataTestId, data, form, } = props;
    const [sortedColumnState, setSortedColumnState] = useState(sortColumn);
    const [sortedDirectionState, setSortedDirectionState] = useState(sortDirection ?? "desc");
    const handleSort = useCallback((headingKey) => {
        const column = headingKey;
        let direction;
        if (sortedColumnState === headingKey) {
            direction = sortedDirectionState === "asc" ? "desc" : "asc";
        }
        else {
            direction = "asc";
        }
        if (onSort) {
            onSort(column, direction);
        }
        setSortedColumnState(column);
        setSortedDirectionState(direction);
    }, [
        sortedColumnState,
        sortedDirectionState,
        onSort,
        setSortedColumnState,
        setSortedDirectionState,
    ]);
    const classes = useTableHeaderClasses(tableTheme);
    const tableHasActions = tableHasAction(props);
    let tableHeadings = headings.map((heading, i) => heading.sortable
        ? {
            ...heading,
            title: (React.createElement(TableHeaderCell, { title: heading.title, onSort: handleSort, sortColumn: sortedColumnState, sortDirection: sortedDirectionState, headingKey: heading.key })),
            className: classNames(classes.sortable, styling === "subdued" || props?.childTable
                ? classes.subduedSortable
                : classes.brandedSortable),
            id: id && `${id}__header-${heading.key}`,
            dataField: `${heading.key}_${i + 1}`,
        }
        : {
            ...heading,
            dataField: `${heading.key}_${i + 1}`,
        });
    if (tableHasActions) {
        tableHeadings.push({ blank: true, title: "" });
    }
    return (React.createElement(ListHeader, { gridClassName: classNames(gridClassName, classes.rowValue), ariaRowIndex: 1, headings: tableHeadings, cellRole: "columnheader", rowRole: "row", className: classes.header, dataId: dataId && `${dataId}-header`, dataTestId: dataTestId && `${dataTestId}-header`, initialiseTabIndex: true, ariaSort: {
            column: sortedColumnState,
            direction: sortedDirectionState,
        }, contained: true, firstColumn: data &&
            form &&
            form?.type === "checkbox" && (React.createElement("div", { "aria-colindex": 1, role: "columnheader", key: 0 }, !props.form?.values || props.loading ? (React.createElement(SkeletonCheckbox, { className: classes.selectAll })) : (React.createElement(SelectAllTableCheckbox, { data: data, form: form, className: classes.selectAll, onChange: onSelectAll, invert: isBulk, dataTestId: dataTestId ? `${dataTestId}-select-all` : undefined, dataId: dataId ? `${dataId}-select-all` : undefined, totalDataLength: props.pagination?.totalRecords })))) }));
}
function useTableHeaderClasses({ header }) {
    const useStyles = createUseStyles({
        rowValue,
        header: {
            borderBottom: header?.borderBottom,
            borderTop: header?.borderTop,
            backgroundColor: `${header?.backgroundColor}`,
            padding: 0,
            transition: THEME.transitions.background,
            "& .list__header": {
                padding: 5,
                color: header?.color,
                fontWeight: header?.fontWeight ?? 400,
                fontSize: header?.fontSize ?? 14,
                textTransform: header?.textTransform ?? "none",
                "&:not(:first-child)": {
                    borderLeft: header?.separator,
                },
            },
        },
        subduedSortable: {
            "&:hover": {
                backgroundColor: "#e0e7ed",
                cursor: "pointer",
            },
        },
        brandedSortable: {
            "&:hover": {
                backgroundColor: THEME.palette.primary.dark.color,
                cursor: "pointer",
            },
        },
        sortable: {
            transition: THEME.transitions.background,
            "&.list__header": {
                padding: 0,
            },
        },
        selectAll: {
            marginBottom: "0 !important",
            padding: [6, 9, 4, 9],
        },
    });
    return useStyles();
}
